<div class="mybets-scoreboard_stats">
    @if (vm()) {
        <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-turn">
            <div class="cell highlight" [ngClass]="{ 'serving-dot': vm().currentlyServing === 1 }"></div>
            <div class="cell highlight" [ngClass]="{ 'serving-dot': vm().currentlyServing === 2 }"></div>
            <div class="cell"></div>
        </div>
    }
    @if (vm()?.matchType === 1) {
        <div class="column">
            <div class="cell">{{ vm().participant1 }}</div>
            <div class="cell">{{ vm().participant2 }}</div>
            <div class="cell-eventdetails">{{ sitecoreEventDetails.eventDetails.Sets }}</div>
        </div>
    }
    @if (vm()?.legs) {
        <div class="column">
            <div class="cell">{{ vm().legs.participant1 }}</div>
            <div class="cell">{{ vm().legs.participant2 }}</div>
            <div class="cell-eventdetails">{{ sitecoreEventDetails.eventDetails.Legs }}</div>
        </div>
    }
</div>
